
import '../../styles/style.css';
// arrays for the skills mapping
import { skills, imageSrc, imageAlt } from '../../utils/consts/skillsInfo';
import { experienceInfo } from '../../utils/consts/experienceInfo';

const AboutMe = () => {
    return (
        // <!-- About Me -->
            <div className="aboutMeContent">
                <h1 className="heading1">Hi, I'm <span className="name">Deris</span></h1>
                <h2 className="heading2">Welcome To My Portfolio</h2>
                <p className="descriptionText">I'm currently a junior at Champlain College studying computer science and an IoT Database Programmer @ The Leahy Center</p>

                <div className="social-icons">
                    <a target="_blank" href="https://www.linkedin.com/in/deris-o-malley-286bbb28b/"><i className='bx bxl-linkedin'></i></a>
                    <a target="_blank" href="https://github.com/DerisO22"><i className='bx bxl-github'></i></a>
                    <a href="#"><i className='bx bxl-twitter'></i></a>
                    <a href="#"><i className='bx bxl-instagram'></i></a>
                </div>

                <a href="/aboutme_assets/DerisOMalley_Current_Resume_Linkedin.docx.pdf" download="/aboutme_assets/DerisOMalley_Current_Resume_Linkedin.docx.pdf" className="btn">Download Resume</a>
                
                <div className="skills">
                    <div className="header">My Skills</div>
                    <div className="skillsContainer">
                        {skills.map((skill, index) => {
                            return (
                                <div key={index} className="skillsBox">
                                    <div className="skillsInfo">
                                        <h4>{skill}</h4>
                                        <img src={`${imageSrc[index]}`} alt={`${imageAlt[index]}`}></img>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>

                <div className="experience">
                    <p className='header'>Experience</p>

                    <div className='experience_container'>
                        {experienceInfo.map((experience, index) => {
                            return (
                                <div key={index}>
                                    <div className="experience_heading_container">
                                        <h2 className="experience_heading1">{experience.title}</h2>
                                        <h3 className="experience_heading2">{experience.status}</h3>
                                    </div>
                                    

                                    <div className="description_container">
                                        {experience.DescriptionPoints.map((descriptionPoint, index) => {
                                            return (
                                                <span key={index} className='descriptionText'>• {descriptionPoint}</span>
                                            )
                                        })}        
                                    </div>
                                    
                                </div>
                            )
                        })}
                    </div>
                </div>

                <div className="bottomText">Explore Around To Learn More About Me!</div>
            </div>
    )
}

export default AboutMe;